export default __webpack_public_path__ + "static/media/floor_type_icon.aa0b487e.svg";